/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

class ResourceCategoryForm extends Component {
  render() {
    const {
      formState,
      loader,
      handleInputChange,
      toggleForm,
      isEditModal,
      createResourceCategory,
      t,
    } = this.props
    return (
      <div id='ResourceCategoryForm' className='row animated fadeIn'>
        <div className='col-md-12'>
          <div className='form-group'>
            <label htmlFor='resource_category_name'>
              {t('resources.categoryForm.categoryName')}
            </label>
            <input
              type='text'
              name='resource_category_name'
              className='form-control'
              id='resource_category_name'
              placeholder={t('resources.categoryForm.categoryName')}
              onChange={handleInputChange}
              value={formState.resource_category_name}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='resource_category_description'>
              {t('common.field.description')}
            </label>
            <textarea
              type='text'
              name='resource_category_description'
              className='form-control'
              id='resource_category_description'
              placeholder={t('common.field.description')}
              onChange={handleInputChange}
              value={formState.resource_category_description}
            />
          </div>
        </div>

        <div className='col-md-12 d-flex justify-content-center align-items-center mt-4'>
          <button
            className='btn btn-dark m-2'
            onClick={() => toggleForm('resource')}
            disabled={loader}
          >
            {t('common.cancel')}
          </button>
          <button
            className='btn btn-primary m-2'
            onClick={createResourceCategory}
            disabled={loader}
          >
            {loader && (
              <i className='fa fa-spinner fa-spin light-loading-spinner' />
            )}
            {t(
              isEditModal
                ? 'resources.categoryForm.editCategory'
                : loader
                  ? 'resources.categoryForm.addingCategory'
                  : 'resources.categoryForm.addCategory'
            )}
          </button>
        </div>
      </div>
    )
  }
}
export default withTranslation()(ResourceCategoryForm)
